import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables!');
  console.error('Please create a .env file based on .env.example');
  console.error('Run `supabase status` to get the URL and anon key');
}

export const supabase = createClient(
  supabaseUrl || 'http://127.0.0.1:54321',
  supabaseAnonKey || 'missing-key',
  {
    realtime: {
      params: {
        eventsPerSecond: 100, // 게임에 필요한 높은 이벤트 빈도
      },
      timeout: 30000, // 30초 타임아웃
      heartbeatIntervalMs: 15000, // 15초마다 heartbeat
    },
  }
);

// Realtime channel for game room
export function createGameChannel(roomId: string, userId: string) {
  return supabase.channel(`game_room:${roomId}`, {
    config: {
      // 모든 수신 핸들러가 자기 이벤트를 무시하므로 에코를 받을 이유가 없고,
      // self: true는 자기가 보낸 트래픽(이동 20Hz + 봇)을 그대로 되받아 대역폭을 2배로 만든다.
      broadcast: { self: false },
      presence: { key: userId },
    },
  });
}
